


















import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import 'open-iconic/font/css/open-iconic.css';
import AnimationState from '@/models/animation_state';
import Settings from './Settings.vue';

@Component@Component({
  components: {
    Settings
  },
})
export default class ControlPanel extends Vue {

  public rewind() {
    store.dispatch('MissionAnimation/UpdateAnimationState', AnimationState.rewind);
  }

  public playPause() {
    window.console.log(`playPause()`);

    const isAnimating = store.getters['MissionAnimation/IsAnimating'];
    window.console.log(`isAnimating: ${isAnimating}`);
    if (isAnimating) {
      store.dispatch('MissionAnimation/UpdateAnimationState', AnimationState.paused);
    } else {
      store.dispatch('MissionAnimation/UpdateAnimationState', AnimationState.playing);
    }
  }

  public settingsClick() {
    window.console.log(`settingsClick()`);
    (this.$refs.settings as Settings).show();
  }
}
